import { createMutation, createQuery } from 'react-query-kit';

import { queryClient } from 'services/http/queryClient';
import portalSchema from 'support/types/schema-portal';

import { fetchData, updateData } from '../../http/http';

export type DocumentUnderstandingAgentSettings =
  portalSchema.components['schemas']['DocumentUnderstandingAgentSettings'];

export type DocumentUnderstandingAgentPricesStrategy =
  portalSchema.components['schemas']['DocumentUnderstandingAgentPricesStrategy'];

export type UpdateDocumentUnderstandingAgentSettingsPayload =
  portalSchema.paths['/v1/partners/current/document-understanding-agent']['put']['requestBody']['content']['application/json'];

export type DocumentUnderstandingAgentRelationshipOverride =
  portalSchema.components['schemas']['DocumentUnderstandingAgentRelationshipOverride'];

type GetDocumentUnderstandingAgentSettingsResponse =
  portalSchema.paths['/v1/partners/current/document-understanding-agent']['get']['responses']['200']['content']['application/json'];

type UpdateDocumentUnderstandingAgentSettingsResponse =
  portalSchema.paths['/v1/partners/current/document-understanding-agent']['put']['responses']['200']['content']['application/json'];

type GetDocumentUnderstandingAgentRelationshipsResponse =
  portalSchema.paths['/v1/partners/current/document-understanding-agent/relationships']['get']['responses']['200']['content']['application/json'];

export const useDocumentUnderstandingAgentSettings = createQuery<DocumentUnderstandingAgentSettings, void, Error>({
  primaryKey: '/partners/current/document-understanding-agent',
  queryFn: async () => {
    const { data } = await fetchData<GetDocumentUnderstandingAgentSettingsResponse>(
      '/v1/partners/current/document-understanding-agent',
    );
    return data.data;
  },
});

export const useUpdateDocumentUnderstandingAgentSettings = createMutation<
  DocumentUnderstandingAgentSettings,
  UpdateDocumentUnderstandingAgentSettingsPayload,
  Error
>({
  mutationFn: async (payload) => {
    const { data } = await updateData<UpdateDocumentUnderstandingAgentSettingsResponse>(
      '/v1/partners/current/document-understanding-agent',
      payload,
    );
    return data.data;
  },
  onSuccess: () => {
    queryClient.invalidateQueries({ queryKey: useDocumentUnderstandingAgentSettings.getKey() });
  },
});

export const useDocumentUnderstandingAgentRelationships = createQuery<
  Array<DocumentUnderstandingAgentRelationshipOverride>,
  void,
  Error
>({
  primaryKey: '/partners/current/document-understanding-agent/relationships',
  queryFn: async () => {
    const { data } = await fetchData<GetDocumentUnderstandingAgentRelationshipsResponse>(
      '/v1/partners/current/document-understanding-agent/relationships',
    );
    return data.data;
  },
});
